let prefix = '/api/sales/client-portfolio';

function exportDocument(){
    return window.axios.post(prefix+'/export-excel', {}, { responseType: 'blob' });
}
export default {
    exportDocument
}